<script lang="ts">
	import { page } from '$app/stores';
	import editorjsHtml from 'editorjs-html';
	import { onMount } from 'svelte';
	import { actionParser, embedParser, tableParser } from './parsers';
	const editorJsParser = editorjsHtml({
		table: tableParser,
		action: actionParser,
		embed: (block) => embedParser(block, $page.data.location.origin)
	});

	export let content: object = {};

	let sanitizedContent: string;

	$: if (content) {
		let parsedContent = editorJsParser.parse(content);
		// sanitizedContent = sanitizeHTML(parsedContent ? parsedContent.join('') : '', sanitizeConf);
		sanitizedContent = parsedContent.join('');
	}

	onMount(() => {
		// const embeds = document.getElementsByClassName(
		// 	'iframe-full-height'
		// ) as HTMLCollectionOf<HTMLIFrameElement>;
		// for (let embedEl of embeds) {
		// 	embedEl.addEventListener('load', (e) => {
		// 		const target = e.target as HTMLIFrameElement;
		// 		console.log(target);
		// 		// console.log(target.contentWindow?.document?.body?.scrollHeight + 20 + 'px');
		// 	});
		// }
	});
</script>

<div class="editor-content">
	{@html sanitizedContent}
</div>
